import { MultiDepotSearchDialog } from "./components/MultiDepotSearchDialog";

export default MultiDepotSearchDialog;